/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */

export default {
	'Type something': 'なにかタイプしてください',
	Advanced: '高度な設定',
	'About Jodit': 'Joditについて',
	'Jodit Editor': 'Jodit Editor',
	"Jodit User's Guide": 'Jodit ユーザーズ・ガイド',
	'contains detailed help for using': '詳しい使い方',
	'For information about the license, please go to our website:':
		'ライセンス詳細についてはJodit Webサイトを確認ください：',
	'Buy full version': 'フルバージョンを購入',
	'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.':
		'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.',
	Anchor: 'Anchor',
	'Open in new tab': '新しいタブで開く',
	'Open in fullsize': 'エディターのサイズ（フル/ノーマル）',
	'Clear Formatting': '書式をクリア',
	'Fill color or set the text color': 'テキストの色',
	Redo: 'やり直し',
	Undo: '元に戻す',
	Bold: '太字',
	Italic: '斜体',
	'Insert Unordered List': '箇条書き',
	'Insert Ordered List': '番号付きリスト',
	'Align Center': '中央揃え',
	'Align Justify': '両端揃え',
	'Align Left': '左揃え',
	'Align Right': '右揃え',
	'Insert Horizontal Line': '区切り線を挿入',
	'Insert Image': '画像を挿入',
	'Insert file': 'ファイルを挿入',
	'Insert youtube/vimeo video': 'Youtube/Vimeo 動画',
	'Insert link': 'リンクを挿入',
	'Font size': 'フォントサイズ',
	'Font family': 'フォント',
	'Insert format block': 'テキストのスタイル',
	Normal: '指定なし',
	'Heading 1': 'タイトル1',
	'Heading 2': 'タイトル2',
	'Heading 3': 'タイトル3',
	'Heading 4': 'タイトル4',
	Quote: '引用',
	Code: 'コード',
	Insert: '挿入',
	'Insert table': '表を挿入',
	'Decrease Indent': 'インデント減',
	'Increase Indent': 'インデント増',
	'Select Special Character': '特殊文字を選択',
	'Insert Special Character': '特殊文字を挿入',
	'Paint format': '書式を貼付け',
	'Change mode': '編集モード切替え',
	Margins: 'マージン',
	top: '上',
	right: '右',
	bottom: '下',
	left: '左',
	Styles: 'スタイル',
	Classes: 'クラス',
	Align: '配置',
	Right: '右寄せ',
	Center: '中央寄せ',
	Left: '左寄せ',
	'--Not Set--': '指定なし',
	Src: 'ソース',
	Title: 'タイトル',
	Alternative: '代替テキスト',
	Link: 'リンク',
	'Open link in new tab': '新しいタブで開く',
	Image: '画像',
	file: 'ファイル',
	'Image properties': '画像のプロパティー',
	Cancel: 'キャンセル',
	Ok: '確定',
	'Your code is similar to HTML. Keep as HTML?': 'HTMLコードを保持しますか？',
	'Paste as HTML': 'HTMLで貼付け',
	Keep: 'HTMLを保持',
	Clean: 'Clean',
	'Insert as Text': 'HTMLをテキストにする',
	'Word Paste Detected': 'Word Paste Detected',
	'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?':
		'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?',
	'Insert only Text': 'テキストだけ',
	'File Browser': 'File Browser',
	'Error on load list': 'Error on load list',
	'Error on load folders': 'Error on load folders',
	'Are you sure?': 'Are you sure?',
	'Enter Directory name': 'Enter Directory name',
	'Create directory': 'Create directory',
	'type name': 'type name',
	'Drop image': 'ここに画像をドロップ',
	'Drop file': 'ここにファイルをドロップ',
	'or click': 'or クリック',
	'Alternative text': '代替テキスト',
	Browse: 'ブラウズ',
	Upload: 'アップロード',
	Background: '背景',
	Text: '文字',
	Top: '上',
	Middle: '中央',
	Bottom: '下',
	'Insert column before': '左に列を挿入',
	'Insert column after': '右に列を挿入',
	'Insert row above': '上に行を挿入',
	'Insert row below': '下に行を挿入',
	'Delete table': '表を削除',
	'Delete row': '行を削除',
	'Delete column': '列を削除',
	'Empty cell': 'セルを空にする',
	'Chars: %d': '文字数: %d',
	'Words: %d': '単語数: %d',
	'Strike through': '取り消し線',
	Underline: '下線',
	superscript: '上付き文字',
	subscript: '下付き文字',
	'Cut selection': '切り取り',
	'Select all': 'すべて選択',
	Break: 'Pause',
	'Search for': '検索',
	'Replace with': '置換',
	Replace: '交換',
	Paste: '貼付け',
	'Choose Content to Paste': '選択した内容を貼付け',
	All: '全部',
	source: 'source',
	bold: 'bold',
	italic: 'italic',
	brush: 'brush',
	link: 'link',
	undo: 'undo',
	redo: 'redo',
	table: 'table',
	image: 'image',
	eraser: 'eraser',
	paragraph: 'paragraph',
	fontsize: 'fontsize',
	video: 'video',
	font: 'font',
	about: 'about',
	print: 'print',
	underline: 'underline',
	strikethrough: 'strikethrough',
	indent: 'indent',
	outdent: 'outdent',
	fullsize: 'fullsize',
	shrink: 'shrink',
	hr: '分割線',
	ul: '箇条書き',
	ol: '番号付きリスト',
	cut: '切り取り',
	selectall: 'すべて選択',
	'Open link': 'リンクを開く',
	'Edit link': 'リンクを編集',
	'No follow': 'No follow',
	Unlink: 'リンク解除',
	Eye: 'サイトを確認',
	' URL': 'URL',
	Reset: 'リセット',
	Save: '保存',
	'Save as ...': 'Save as ...',
	Resize: 'リサイズ',
	Crop: 'Crop',
	Width: '幅',
	Height: '高さ',
	'Keep Aspect Ratio': '縦横比を保持',
	Yes: 'はい',
	No: 'いいえ',
	Remove: '移除',
	Select: '選択',
	'Select %s': '選択: %s',
	Update: '更新',
	'Vertical align': '垂直方向の配置',
	Merge: 'セルの結合',
	'Add column': '列を追加',
	'Add row': '行を追加',
	Border: '境界線',
	'Embed code': '埋め込みコード',
	Delete: '削除',
	Edit: '編集',
	'Horizontal align': '水平方向の配置',
	Filter: 'Filter',
	'Sort by changed': 'Sort by changed',
	'Sort by name': 'Sort by name',
	'Sort by size': 'Sort by size',
	'Add folder': 'Add folder',
	Split: '分割',
	'Split vertical': 'セルの分割（垂直方向）',
	'Split horizontal': 'セルの分割（水平方向）',
	'You can only edit your own images. Download this image on the host?':
		'You can only edit your own images. Download this image on the host?',
	'The image has been successfully uploaded to the host!':
		'The image has been successfully uploaded to the host!',
	palette: 'パレット',
	pencil: '鉛筆',
	'There are no files': 'There are no files',
	Rename: 'Rename',
	'Enter new name': 'Enter new name',
	preview: 'プレビュー',
	download: 'ダウンロード',
	'Paste from clipboard': '貼り付け',
	"Your browser doesn't support direct access to the clipboard.":
		'お使いのブラウザはクリップボードを使用できません',
	'Copy selection': 'コピー',
	copy: 'copy',
	'Border radius': '角の丸み',
	'Show all': '全て表示',
	Apply: '適用',
	'Please fill out this field': 'まだこの分野',
	'Please enter a web address': 'を入力してくださいウェブアドレス',
	Default: 'デフォルト',
	Circle: '白丸',
	Dot: '黒丸',
	Quadrate: '四角',
	Find: '見',
	'Find Previous': '探前',
	'Find Next': '由来',
	'Lower Alpha': '英小文字',
	'Lower Greek': 'ギリシャ文字',
	'Lower Roman': 'ローマ数字小文字',
	'Upper Alpha': '英大文字',
	'Upper Roman': 'ローマ数字大文字',
	'Insert className': 'クラス名を挿入',
	'Press Alt for custom resizing':
		'カスタムサイズ変更のためのAltキーを押します'
};
